import React from 'react';
import Table from '../Table';
import PropTypes from 'prop-types';
import { TableSkeleton } from '../../pages/overallPerformance/components/TableSkeleton';
import ErrorText from '../ErrorText';
import NoData from '../NoData';
import { getColorStyleForCell } from '../../utils/colorSchmeOverallPerformance';

const BaseTable = ({
  data,
  columns,
  isLoading,
  error,
  skeletonProps = { rows: 8, columns: 4, height: '300px' },
  showNoStoreSelected = false,
}) => {
  if (isLoading) {
    return <TableSkeleton {...skeletonProps} />;
  }

  if (error) {
    return <ErrorText reason={error} />;
  }

  if (!data || data.length === 0 || showNoStoreSelected) {
    return <NoData textValue={showNoStoreSelected && 'Please select branch to see the data'} />;
  }

  return (
    <div className="table-container">
      <Table
        data={data}
        columns={columns}
        getCellProps={(cellInfo) => {
          if (['percentToPlan', 'percentToPrevYear'].includes(cellInfo.column.id)) {
            return {
              style: {
                ...getColorStyleForCell(cellInfo.row.original.viewData, cellInfo.value),
              },
            };
          } else {
            return {
              style: {},
            };
          }
        }}
        applyStyleToLastRow
      />
    </div>
  );
};

BaseTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]),
  skeletonProps: PropTypes.shape({
    rows: PropTypes.number,
    columns: PropTypes.number,
    height: PropTypes.string,
  }),
  showNoStoreSelected: PropTypes.bool,
};

export default BaseTable;
